import {useEffect} from "react";
import {Outlet, useLocation} from "react-router-dom";

import {getPageTitle} from "../../utils/pageTitles";

// Keeps the browser-tab title (document.title) in sync with the current route.
// Mounted once as a pathless layout route wrapping the whole app, so it updates
// on every navigation without each page having to set its own title.
const TitleManager = () => {
    const {pathname} = useLocation();

    useEffect(() => {
        document.title = getPageTitle(pathname);
    }, [pathname]);

    return <Outlet/>;
};

export default TitleManager;
